import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=50f576ba&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=50f576ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f576ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50f576ba')) {
      api.createRecord('50f576ba', component.options)
    } else {
      api.reload('50f576ba', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=50f576ba&scoped=true&", function () {
      api.rerender('50f576ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27a8OrIval0uW/JS/comp/PopupDialog.vue"
export default component.exports